import type { SVGProps } from 'react';
const SvgInfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <desc>{'Information Circle Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.941 17.32v-6.127a.875.875 0 0 0-.875-.876h-.875M11.504 7.729a.438.438 0 1 1 0-.875M11.504 7.729a.438.438 0 1 0 0-.875"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 23.228c6.201 0 11.228-5.027 11.228-11.228S18.201.772 12 .772.772 5.799.772 12 5.799 23.228 12 23.228"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M10.19 17.32h3.62"
    />
  </svg>
);
export default SvgInfoCircle;
